import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Component } from 'react';
import SVGs from 'il-framework-icons/output/il-framework-icons.svg';

var initialized = false;
var IlIconInitializer = /*#__PURE__*/function (_Component) {
  function IlIconInitializer() {
    _classCallCheck(this, IlIconInitializer);
    return _callSuper(this, IlIconInitializer, arguments);
  }
  _inherits(IlIconInitializer, _Component);
  return _createClass(IlIconInitializer, [{
    key: "render",
    value: function render() {
      if (!initialized) {
        initialized = true;
        document.body.insertAdjacentHTML('beforeend', "<div class=\"hidden\">".concat(SVGs, "</div>"));
      }
      return null;
    }
  }]);
}(Component);

export { IlIconInitializer };
